export const Seeds: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.4321 20.0605L20.696 30.4854C18.8411 31.7976 16.2738 31.3577 14.9616 29.5029C14.4696 28.8073 14.6346 27.8446 15.33 27.3524L23.0589 21.8848"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8924 19.5166L29.9817 32.4544C28.6929 34.3257 26.1312 34.7977 24.2601 33.5089C23.5584 33.0257 23.3813 32.065 23.8646 31.3633L27.9599 25.4172"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.1392 17.8697L62.2274 17.0875C62.4001 15.3253 64.4395 7.21844 73.6914 3.21484"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5208 15.9365L13.8279 17.4542C13.3172 17.57 12.984 18.0621 13.0661 18.5793L13.076 18.6412C13.4618 21.0704 15.7308 22.7348 18.1622 22.3723C25.0913 21.3395 38.469 19.3529 45.2155 18.3514C47.7424 17.9762 50.2696 19.0217 51.794 21.0718C53.3107 23.1118 53.6035 25.8132 52.5588 28.1307L51.4022 30.6967C50.2935 33.1564 50.5694 36.0192 52.1277 38.2217C53.3061 39.8875 55.6118 40.2825 57.2774 39.1039C57.6624 38.8314 57.821 38.3373 57.6665 37.8917L57.0729 36.1803C56.5405 34.6456 56.7416 32.9514 57.6186 31.5839L59.3165 28.9365C60.3579 27.3128 61.0922 25.5171 61.4888 23.639L61.5227 23.3387"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.3717 3.2041C51.8504 4.34363 50.2211 5.33598 48.5051 6.16598L39.9711 10.2944C36.7854 11.8355 33.4345 13.0088 29.9833 13.7913L25.8667 14.7247"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.203 45.1811C45.5586 46.5569 46.9622 47.3841 48.338 47.0285C49.7137 46.6729 50.5409 45.2693 50.1853 43.8935C49.5715 41.5185 46.4651 39.7822 46.4651 39.7822C46.4651 39.7822 44.5892 42.8063 45.203 45.1811Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4538 40.6628C30.449 41.6677 30.449 43.2967 31.4538 44.3016C32.4587 45.3064 34.0877 45.3064 35.0926 44.3016C36.8271 42.567 36.746 39.0094 36.746 39.0094C36.746 39.0094 33.1884 38.9283 31.4538 40.6628Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7466 55.3892C36.7466 57.1861 38.2033 58.6428 40.0002 58.6428C41.7971 58.6428 43.2538 57.1861 43.2538 55.3892C43.2538 52.2873 40.0002 49.1787 40.0002 49.1787C40.0002 49.1787 36.7466 52.2873 36.7466 55.3892Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.0855 29.9056C38.3562 31.5479 39.0964 33.4704 40.7387 34.1996C42.3811 34.9289 44.3036 34.1887 45.0328 32.5464C46.2917 29.7114 44.5795 25.5498 44.5795 25.5498C44.5795 25.5498 40.3444 27.0706 39.0855 29.9056Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.8281 60.6982H69.885C68.6891 60.6982 67.5839 61.3362 66.9859 62.372L64.9069 65.9731C63.2775 68.7953 59.2041 68.7953 57.5747 65.9731L55.4956 62.372C54.8977 61.3362 53.7925 60.6982 52.5966 60.6982H48.9012C47.7053 60.6982 46.6002 61.3362 46.0022 62.372L43.9231 65.9731C42.2938 68.7953 38.2203 68.7953 36.5909 65.9731L34.5119 62.372C33.9139 61.3362 32.8088 60.6982 31.6128 60.6982H27.7611C26.5652 60.6982 25.46 61.3362 24.862 62.372L22.783 65.9731C21.1536 68.7953 17.0802 68.7953 15.4508 65.9731L13.3717 62.372C12.7738 61.3362 11.6686 60.6982 10.4727 60.6982H1.17188"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.996 60.3865L5.94569 59.7345C2.26459 57.4493 0.451 53.071 1.43819 48.8523L1.85475 47.0723L3.40787 48.0365C5.2485 49.179 6.62209 50.8449 7.41225 52.7524"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1743 56.6875C11.3853 57.893 10.3314 58.9402 9.05184 59.7344L8.11621 60.3152"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40723 60.3073L7.08223 58.9187C6.09504 54.6999 7.90864 50.3215 11.5897 48.0365L13.1429 47.0723L13.5594 48.8523C13.7638 49.7259 13.8482 50.6063 13.8207 51.4737"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.322 60.5876L70.9476 59.7345C67.2665 57.4493 65.453 53.071 66.4401 48.8523L66.8567 47.0723L68.4098 48.0365C70.2505 49.179 71.624 50.8449 72.4142 52.7524"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.4401 60.4379L72.0847 58.9187C71.0975 54.6999 72.9111 50.3215 76.5922 48.0365L78.1453 47.0723L78.5619 48.8523C79.549 53.071 77.7355 57.4495 74.0544 59.7345L72.749 60.5448"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
